/* eslint-disable react/display-name */
import { TrajectoryWidgetWrapper } from '../../trajectory-widget/TrajectoryWidget';
import type { TrajectoryWidgetEntity } from '../../trajectory-widget/TrajectoryWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderTrajectoryWidget(widget: TrajectoryWidgetEntity, options: TWidgetRendererOptions): TRenderWidget {
  return () => <TrajectoryWidgetWrapper entity={widget} options={options} />;
}
